import React, { Fragment } from 'react';
import DesktopSidebar from './desktop';
import MobileSidebar from './mobile';
import { Desktop, Tablet, Mobile } from '../../../layouts/devices-sizes';

// type Props = {
//   user: UserModel.t,
//   showLivePage: boolean,
//   showDemoLivePage: boolean,
//   showHeadcountPlanner: Boolean,
//   logout: (options: Object) => void | Promise<Object>,
//   reports?: ReportModel.t[],
//   location: Object,
// };

// type MenuItemT = {
//   label: string,
//   icon?: string,
//   path: string,
//   children?: MenuItemT[],
// };


const Sidebar = (props) => {  // type Props

  const menuItems = [
    {
      label: 'Clients',
      icon: 'office',
      path: '/orgs',
    },
    {
      label: 'Locations',
      icon: 'area-of-interest',
      path: '/locs',
    },
    {
      label: 'Devices',
      icon: 'desktop',
      path: '/devs',
    },
    {
      label: 'Cameras',
      icon: 'camera',
      path: '/recs',
    },
  ];

  return (
    <Fragment>
      <Mobile className={'sidebar'}>
        <MobileSidebar
          {...props}
          logout={'/logout'}
          menuItems={menuItems}
        />
      </Mobile>
      <Tablet className={'sidebar'}>
        <DesktopSidebar
            {...props}
            logout={'/logout'}
            menuItems={menuItems}
        />
      </Tablet>
      <Desktop className={'sidebar'}>
        <DesktopSidebar
          {...props}
          logout={'/logout'}
          menuItems={menuItems}
        />
      </Desktop>
    </Fragment>
  );
};

export { Sidebar };
